import React, { Component } from 'react';
import axios from 'axios';
import { Base64 } from 'js-base64';

export default class RecordingVipStatiticPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recordingsVip: null,
      loading: false,
      statusButtonLoadPage: false,
      startDate: null,
      endDate: null,
    }
    this.getVipRecordingStatitic = this.getVipRecordingStatitic.bind(this);
  }

  componentDidMount() {
    this.getVipRecordingStatitic();
  }

  getVipRecordingStatitic() {
    const { loading } = this.state;
    let json = {
      startDate: this.state.startDate,
      endDate: this.state.endDate,
    }
    let parameterInString = Base64.encode(JSON.stringify(json))
    if (!loading) {
      this.setState({
        loading: true
      });
      axios.post(`${global.config.apiDomain}/v45.GetUsedAICards?parameters=${parameterInString}`)
        .then(res => {
          this.setState({
            recordingsVip: res?.data?.data ?? [],
            loading: false
          })
        })
        .catch(err => {
          this.setState({
            recordingsVip: [],
            loading: false
          })
        });
    }
  }


  render() {
    const { recordingsVip, loading } = this.state;
    
    return (
      <>
        <div id="content" 
          style={{
            width: "70%",
            marginLeft: "auto",
            marginRight: "auto"
          }}
        >
          <div className="container-fluid">
            <h1 className="text-center">Thống kê thẻ Xử lý Bài thu</h1>
            <hr></hr>
            <div className='d-flex align-items-center mb-2'>
              <div className="mb-3">
                <label className="me-2">Từ ngày:</label>
                <input
                  type="date"
                  value={this.state.startDate}
                  onChange={(e) => {
                    this.setState({ startDate: e.target.value }, () => {
                      if (this.state.startDate !== '' && this.state.endDate !== '') {
                        this.getVipRecordingStatitic();
                      }
                    });
                  }}
                  className="form-control"
                />
              </div>
              <div className="mb-3 ml-2">
                <label className="me-2">Đến ngày:</label>  
                <input
                  type="date"
                  value={this.state.endDate}
                  onChange={(e) => {
                    this.setState({ endDate: e.target.value }, () => {
                      if (this.state.startDate !== '' && this.state.endDate !== '') {
                        this.getVipRecordingStatitic();
                      }
                    });
                  }}
                  className="form-control"
                />
              </div>
              <button className="btn btn-light ml-2 mt-3" 
                onClick={() => {
                  this.setState({
                    startDate: "",
                    endDate: "",
                  }, () => {
                    this.getVipRecordingStatitic();
                  })
                }}>
                <i className="fa fa-refresh"></i>
              </button>
            </div>
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Trạng thái</th>
                  <th scope="col">Số lượng</th>
                </tr>
              </thead>
              <tbody>
                {(recordingsVip || []).map((item, index) => {
                  return (
                    <tr key={index}>
                      <td className="align-middle">{index + 1}</td>
                      <td className="align-middle">{item.type}</td>
                      <td className="align-middle">{item.amount}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  }
}